export default "__VITE_ASSET__61fc9a72__"